import React, { useState } from "react";
import QuietNavbar from "./shared/QuietNavbar.jsx";
import QuietFooter from "./shared/QuietFooter.jsx";
import QuietHero from "./sections/QuietHero.jsx";
import QuietInterceptSection from "./sections/QuietInterceptSection.jsx";
import QuietProofSection from "./sections/QuietProofSection.jsx";
import LeadCaptureModal from "./modal/LeadCaptureModal.jsx";

const MainLanding = () => {
  const [isLeadModalOpen, setIsLeadModalOpen] = useState(false);

  const openLeadModal = () => setIsLeadModalOpen(true);
  const closeLeadModal = () => setIsLeadModalOpen(false);

  return (
    <div className="quiet-landing min-h-screen" data-testid="quiet-landing">
      <QuietNavbar onSignUp={openLeadModal} />
      <div className="h-14 md:h-16" aria-hidden="true" />
      <div className="cursor-grid-shell">
        <main>
          <QuietHero onOpenModal={openLeadModal} />
          <QuietInterceptSection />
          <QuietProofSection />
        </main>
        <QuietFooter />
      </div>
      <LeadCaptureModal isOpen={isLeadModalOpen} onClose={closeLeadModal} />
    </div>
  );
};

export default MainLanding;
